/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Preview_HintInputs */

const vi_media_preview_hint = /** @type {(inputs: Media_Preview_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng phím mũi tên trái/phải để xem tệp trước hoặc sau`)
};

/**

* @param {Media_Preview_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_preview_hint = /** @type {((inputs?: Media_Preview_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Preview_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_preview_hint(inputs)
});